import { render, staticRenderFns } from "./VideoWidget.vue?vue&type=template&id=3e2f86a1&scoped=true"
import script from "./VideoWidget.vue?vue&type=script&lang=js"
export * from "./VideoWidget.vue?vue&type=script&lang=js"
import style0 from "./VideoWidget.vue?vue&type=style&index=0&id=3e2f86a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f86a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e2f86a1')) {
      api.createRecord('3e2f86a1', component.options)
    } else {
      api.reload('3e2f86a1', component.options)
    }
    module.hot.accept("./VideoWidget.vue?vue&type=template&id=3e2f86a1&scoped=true", function () {
      api.rerender('3e2f86a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/VideoWidget.vue"
export default component.exports